import { store } from "../store";
import { getWidgetConfig } from "../reducers/methods";
import { StoreState } from "../reducers/";
import { sendElementMoved } from "../actions";
import { Action } from "redux";

export function isEditMode(): boolean {
  const state = store.getState() as StoreState;
  const config = getWidgetConfig(state);

  return config && config.__editMode__;
}

export function sendMoveToMerchant(
  event: MouseEvent,
  configName: string,
  newStyle: {
    left: string;
    top: string;
    height: string;
    width: string;
  }
): boolean {
  if (isEditMode()) {
    event.stopPropagation();
    event.preventDefault();

    store.dispatch(sendElementMoved(event, configName, newStyle) as Action);

    return true;
  }

  return false;
}
